import { testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section aria-labelledby="home-testimonials" className="bg-secondary-950 py-16 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <h2 id="home-testimonials" className="font-heading text-2xl font-black text-background-50 md:text-3xl">
          使用者的真实反馈
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-200/75">
          他们用公告库来核对信息、对齐口径，也把这里当成核实传闻的第一站。
        </p>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure key={item.author} className="flex h-full flex-col rounded-lg border border-background-50/10 bg-background-50/5 p-6">
              <span className="flex h-8 w-8 items-center justify-center text-2xl text-accent-400">
                <i className="ri-double-quotes-l" />
              </span>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-background-100/90">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-background-50/10 pt-4">
                <span className="block font-heading text-sm font-bold text-background-50">{item.author}</span>
                <span className="mt-0.5 block text-xs text-background-200/70">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}